import(/* webpackMode: "eager" */ "/home/uzouser/front/uzo_2026_front/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/uzouser/front/uzo_2026_front/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/uzouser/front/uzo_2026_front/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionRecoveryDialog"] */ "/home/uzouser/front/uzo_2026_front/src/components/auth/SessionRecoveryDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelpProvider"] */ "/home/uzouser/front/uzo_2026_front/src/components/help/help-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocumentTitle"] */ "/home/uzouser/front/uzo_2026_front/src/components/layout/DocumentTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/uzouser/front/uzo_2026_front/src/components/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorReporter"] */ "/home/uzouser/front/uzo_2026_front/src/components/providers/ClientErrorReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/home/uzouser/front/uzo_2026_front/src/components/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastPolicy"] */ "/home/uzouser/front/uzo_2026_front/src/components/providers/ToastPolicy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialogHost"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorBoundary"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/async-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmDialogHost"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/confirm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeleteReasonDialogHost"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/delete-reason-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromptDialogHost"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/prompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/uzouser/front/uzo_2026_front/src/components/ui/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerfReporter"] */ "/home/uzouser/front/uzo_2026_front/src/lib/perf-reporter.ts");
